export default __webpack_public_path__ + "static/media/Pc3.9ad63c32.jpg";